import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { AdminTable } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';
import { SubTabs } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { SubTabsHeader } from 'apps/sigma2-ui/src/components/ui/SubTabs';
import { useSubTabs } from 'apps/sigma2-ui/src/lib/hooks/useSubTabGroup';
import { useDatabasesDataSetsPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabasesDataSetsPage';

export const DatabasesDataSetsPage = () => {
  const {
    organizationId,
    databaseId,
    databaseName,
    activeRows,
    archivedRows,
    headings,
    newDataSetButtonLabel,
    newDataSetButtonBehavior,
    continueToTransformButtonBehavior,
    continueToTransformButtonLabel,
    continueToTransformButtonDisabled,
    backButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
  } = useDatabasesDataSetsPage();

  const tabs = useSubTabs({
    tabDefinitions: [
      {
        header: ({ isSelected }) => (
          <SubTabsHeader isSelected={isSelected} translatedContent={'Active'} />
        ),
        body: () => <AdminTable headings={headings} rows={activeRows} />,
      },
      {
        header: ({ isSelected }) => (
          <SubTabsHeader
            isSelected={isSelected}
            translatedContent={'Archived'}
          />
        ),
        body: () => <AdminTable headings={headings} rows={archivedRows} />,
      },
    ],
  });

  return (
    <AdminLayout currentPage={'DatabasesDataSets'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
          {
            label: 'Data Sets',
            to: `/organizations/${organizationId}/databases/${databaseId}/data-sets`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <Paragraph>
          Use the table below to manage an existing data set or create a new
          one. On the next screen, you can select the data sets that you would
          like to use for transformation.
        </Paragraph>
        <Paragraph>Database: {databaseName}</Paragraph>

        <Button
          behavior={newDataSetButtonBehavior}
          text={newDataSetButtonLabel}
        />

        <SubTabs
          tabDefinitions={tabs.tabDefinitions}
          onTabChange={tabs.onTabChange}
          selectedTabIndex={tabs.selectedTabIndex}
        />

        <Spacing size="sm" direction="horizontal">
          <Button
            behavior={backButtonBehavior}
            text={backButtonLabel}
            disabled={backButtonDisabled}
          />

          <Button
            behavior={continueToTransformButtonBehavior}
            text={continueToTransformButtonLabel}
            disabled={continueToTransformButtonDisabled}
          />
        </Spacing>
      </Spacing>
    </AdminLayout>
  );
};
